import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index.vue')
  },
  //班车时刻表
  {
    path: '/bcskb',
    name: 'BusTimetable',
    component: () => import('../views/BusTimetable.vue')
  },
  //班车详情
  {
    path: '/bcskb/bcxq',
    name: 'BusDetails',
    component: () => import('../views/BusDetails.vue')
  },
  //站点列表
  {
    path: '/zdlb',
    name: 'SiteList',
    component: () => import('../views/SiteList.vue')
  },
  //站点线路
  {
    path: '/zdxl',
    name: 'StationLine',
    component: () => import('../views/StationLine.vue')
  },
  //线路详情
  {
    path: '/zdxl/xlxq',
    name: 'RouteDetails',
    component: () => import('../views/RouteDetails.vue')
  },
  //线路图
  {
    path: '/zdxl/xlxq/xlt',
    name: 'CircuitDiagram',
    component: () => import('../views/CircuitDiagram.vue')
  },
  //收藏夹
  {
    path: '/scj',
    name: 'Favorite',
    component: () => import('../views/Favorite.vue')
  },
  //寒假班车
  {
    path: '/hjbc',
    name: 'WinterVacationBus',
    component: () => import('../views/WinterVacationBus.vue')
  },
  //查询结果
  {
    path: '/cxjg',
    name: 'QueryResults',
    component: () => import('../views/QueryResults.vue')
  },
  //时刻表
  {
    path: '/skb',
    name: 'TimeTable',
    component: () => import('../views/TimeTable.vue')
  },
  //浙江大学校园循环车查询系统
  {
    path: '/xbc',
    name: 'CycleCar',
    component: () => import('../views/CycleCar/Index.vue')
  },
  //浙江大学校园循环车 - 时刻表
  {
    path: '/xbc/detail',
    name: 'CycleCar',
    component: () => import('../views/CycleCar/TimeDetail.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
